export enum IconColor {
  Blue800 = 'blue800',
  AlternativesGray900 = 'alternativesGray900',
  Gray900 = 'gray900',
  Orange500 = 'orange500',
  Red600 = 'red600',
}
